import {
  SYMBOLS,
  detectMarketFromSymbol,
  formatTimeframeLabel,
} from "../tradingRuntimeConfig";

export const RADAR_TIMEFRAMES = [180, 300, 900];
export const RADAR_HISTORY_TIMEFRAMES = [180, 300, 900, 1800];
export const RADAR_SYMBOLS = [...(SYMBOLS.BOOM || []), ...(SYMBOLS.CRASH || [])];
export const RADAR_DEFAULT_SL_PIPS = 15;
export const RADAR_HISTORY_CACHE_MS = 12000;
export const RADAR_TICK_MS = 1500;
export const RADAR_MAX_CONCURRENT_SCANS = 2;
export const RADAR_ALERT_DEDUPLICATION_MS = 90000;
export const RADAR_LOG_LIMIT = 30;
export const RADAR_PRIORITY_ORDER = {
  HIGH_PRIORITY: 3,
  MEDIUM_PRIORITY: 2,
  WATCHLIST: 1,
};

export const RADAR_SCAN_INTERVALS_MS = {
  idle: 30000,
  warm: 18000,
  hot: 9000,
  cooldown: 45000,
};

export function buildRadarTargets() {
  return RADAR_SYMBOLS.flatMap((symbol) =>
    RADAR_TIMEFRAMES.map((timeframe) => ({
      id: `${symbol}:${timeframe}`,
      symbol,
      timeframe,
      market: detectMarketFromSymbol(symbol),
      timeframeLabel: formatTimeframeLabel(timeframe),
      nextScanAt: 0,
      hotness: "idle",
    }))
  );
}
